import { createBrowserReporter, installBrowserCapture } from "@techlocal/observability/browser";
import { getSupabaseBrowserClient } from "@/lib/supabase/client";
let token = "";
export const reportBrowserError = createBrowserReporter({ endpoint: "/api/observability",
 release: process.env.NEXT_PUBLIC_OBSERVABILITY_RELEASE || "0000000", getToken:()=>token,
 // Same-origin cookie authentication, token is only a local authenticated-session gate.
 fetchImpl:(input,init)=>fetch(input,{...init,credentials:"same-origin",headers:{"Content-Type":"application/json"}}),
});
export function installCapture(){
 const client=getSupabaseBrowserClient();
 void client.auth.getSession().then(({data})=>{token=data.session?.access_token||"";});
 client.auth.onAuthStateChange((_event,session)=>{token=session?.access_token||"";});
 return installBrowserCapture(reportBrowserError);
}
